import { CsvRawDataRow } from './CsvRawDataRow';

interface CsvRawDataRowSanitiserResult {
  items: CsvRawDataRow[];
  summary: CsvRawDataRowSanitiserSummary;
}

export interface CsvRawDataRowSanitiserSummary {
  blankColumns: number[];
  incorrectColumns: number[];
  headerColumnCount: number;
  errors: number;
}

type CsvRawDataRowSanitiserSummmary = {
  blankColumns: number[];
  incorrectColumns: number[];
  headerColumnCount: number;
  errors: 0;
};

export function CsvRawDataRowSanitiser(data: CsvRawDataRow[]): CsvRawDataRowSanitiserResult {
  const headerColumnCount = data[0].data.length;
  const goodItems = data.filter((x) => x.data.length === headerColumnCount);

  const summary: CsvRawDataRowSanitiserSummmary = {
    blankColumns: [],
    incorrectColumns: [],
    headerColumnCount: headerColumnCount,
    errors: 0
  };

  // Loop and get row indexes
  data.forEach((d, i) => {
    if (d.data.length > 1 && d.data.length != headerColumnCount) {
      summary.incorrectColumns.push(i + 1);
    }
    if (d.data.length <= 1) {
      summary.blankColumns.push(i + 1);
    }
  });

  return {
    items: goodItems,
    summary: { ...summary, errors: summary.incorrectColumns.length + summary.blankColumns.length }
  };
}
